import { render } from "./Custom.vue?vue&type=template&id=78b4e410&scoped=true&ts=true"
import script from "./Custom.vue?vue&type=script&lang=ts"
export * from "./Custom.vue?vue&type=script&lang=ts"

import "./style/index.scss?vue&type=style&index=0&id=78b4e410&lang=scss&scoped=true"

import exportComponent from "/Users/ls/Documents/维思英才/webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b4e410"]])

export default __exports__